export default __webpack_public_path__ + "static/media/029-samurai.a6c514b9.svg";